export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10489.a061460b.jpg";